import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import auth from "@/views/login/auth";
import Vue from 'vue';
import { mapGetters } from "vuex";
import qianKunRun from "@/views/qiankun";
import MobileTips from "@/components/mobile";
export default {
  components: {
    MobileTips: MobileTips
  },
  computed: _objectSpread({}, mapGetters(["mapSkin"])),
  created: function created() {
    // 应用首次进入存储事件统计公用参数
    Vue.prototype.$EventStatis.getSystemMsg();
  },
  data: function data() {
    return {
      isShowMobileTips: this.isMobile()
    };
  },
  // 在此处添加路由路径检测 用于访问量统计
  watch: {
    $route: function $route(to) {
      auth.invalidationTimeliness(); // 切换路由进行验证
      // 统计路径

      this.addIstrongTrackEvent(to.name); // 添加统计，无论成功与否

      if (window.GLOBAL_CONFIG) {
        this.addBaiduTrackEvent(["_trackPageview", to.path]);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 统计访客
    if (window.GLOBAL_CONFIG) {
      var userName = window.GLOBAL_CONFIG.projectId;
      this.addBaiduTrackEvent(["_setCustomVar", 1, userName, "常规访客", 2]);
    }

    qianKunRun(); // 执行乾坤组件
    // 全局挂载音频变量

    var music = new Audio();
    document.addEventListener('click', function () {
      if (_this.$autio) return;
      Vue.prototype.$autio = music;
      music.src = "./autio/null.mp3";
      music.play(); // 设置为本地保存声音提醒开启或关系

      var voice = localStorage.getItem("NOTICE"); // 本地未保存设置且第一次点击监听默认为开启

      if (voice === null) localStorage.setItem('NOTICE', JSON.stringify({
        isOpen: true
      }));
    });
  },
  methods: {
    isMobile: function isMobile() {
      var flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      return flag;
    }
  }
};